export default "__VITE_ASSET__Dx6H8HDk__"